"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableTable = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Util_1 = __importDefault(require("@common/Util"));
class SortableTable {
    constructor(headers, divName) {
        this.headers = [];
        this.rows = [];
        this.sortHeader = null;
        this.fitToViewport = true;
        this.hiddenColumns = [];
        this.headers = headers;
        this.divName = divName;
        for (const col of headers) {
            if (col.defaultSort) {
                this.sortHeader = col;
                return;
            }
        }
    }
    addRow(row) {
        for (const cell of row) {
            if (cell.value === null || cell.value === "null") {
                cell.value = "N/A";
                cell.html = "N/A";
            }
        }
        this.rows.push(row);
    }
    addRows(rows) {
        for (const row of rows) {
            for (const cell of row) {
                if (cell.value === null || cell.value === "null") {
                    cell.value = "N/A";
                    cell.html = "N/A";
                }
            }
        }
        this.rows = rows;
    }
    sort(colId) {
        for (const c of this.headers) {
            if (c.id === colId) {
                if (c.sortable === true) {
                    if (this.sortHeader !== null && this.sortHeader.id === c.id) {
                        c.sortDown = !c.sortDown;
                    }
                    this.sortHeader = c;
                }
                else {
                    this.sortHeader = null;
                }
            }
        }
        this.generate();
    }
    generate() {
        Log_1.default.trace("SortableTable::generate() - start");
        const that = this;
        this.performSort();
        let table = "";
        table += this.startTable();
        let isOdd = false;
        for (const row of this.rows) {
            table += this.generateRow(row, isOdd);
            isOdd = !isOdd;
        }
        table += this.endTable();
        const div = document.querySelector(this.divName);
        if (div !== null) {
            div.innerHTML = "";
            div.innerHTML = table;
            const ths = div.getElementsByTagName("th");
            const thsArray = Array.prototype.slice.call(ths, 0);
            for (const th of thsArray) {
                th.onclick = function () {
                    const colName = this.getAttribute("col");
                    that.sort(colName);
                };
            }
        }
        else {
            Log_1.default.error("SortableTable::generate() - " + this.divName + " is null");
        }
        this.attachDownload();
        if (this.fitToViewport === false) {
            if (div !== null) {
                div.style.height = "";
            }
            return;
        }
        setTimeout(() => {
            Log_1.default.info("SortableTable::generate() - updating table height; div: " + this.divName);
            this.updateTableHeight();
        }, 100);
        window.addEventListener("resize", (evt) => {
            Log_1.default.info("SortableTable::generate()::resize - div: " + this.divName);
            this.updateTableHeight();
        }, true);
    }
    isDrawn(header) {
        return typeof header === "undefined" || this.hiddenColumns.indexOf(header.id) < 0;
    }
    startTable() {
        let tablePrefix = '<table class="sortableTable">';
        tablePrefix += "<tr>";
        for (const header of this.headers) {
            if (this.isDrawn(header) === false) {
                continue;
            }
            if (typeof header.style === "undefined") {
                header.style = "";
            }
            const title = typeof header.tooltip === "string" && header.tooltip.length > 0 ? ' title="' + SortableTable.escapeHTML(header.tooltip) + '"' : "";
            const id = SortableTable.escapeHTML(header.id);
            const text = SortableTable.escapeHTML(header.text);
            if (this.sortHeader !== null && header.id === this.sortHeader.id) {
                if (this.sortHeader.sortDown === false) {
                    tablePrefix +=
                        '<th class="sortableHeader" style="' +
                            header.style +
                            '" col="' +
                            id +
                            '"' +
                            title +
                            '><b class="sortableHeader">' +
                            text +
                            " ▲</b></th>";
                }
                else {
                    tablePrefix +=
                        '<th class="sortableHeader"  style="' +
                            header.style +
                            '" col="' +
                            id +
                            '"' +
                            title +
                            '><b class="sortableHeader">' +
                            text +
                            " ▼</b></th>";
                }
            }
            else {
                tablePrefix += '<th class="sortableHeader" style="' + header.style + '" col="' + id + '"' + title + ">" + text + "</th>";
            }
        }
        tablePrefix += "</tr>";
        return tablePrefix;
    }
    endTable() {
        const tableSuffix = "</table>";
        return tableSuffix;
    }
    generateRow(cols, isOdd) {
        let row = "";
        if (isOdd) {
            row = '<tr class="sortableTableRow" style="color: black; background: white;">';
        }
        else {
            row = '<tr class="sortableTableRow" style="color: black; background: lightgrey;">';
        }
        let i = 0;
        for (const col of cols) {
            if (this.isDrawn(this.headers[i]) === true) {
                row += '<td class="sortableTableCell" style="color: black; ' + this.headers[i].style + '">' + col.html + "</td>";
            }
            i++;
        }
        row += "</tr>";
        return row;
    }
    performSort() {
        let sortHead = null;
        let sortIndex = 0;
        if (this.sortHeader === null) {
            return;
        }
        for (const head of this.headers) {
            if (head.id === this.sortHeader.id) {
                if (head.sortable === false) {
                    return;
                }
                else {
                    sortHead = head;
                }
            }
            if (sortHead === null) {
                sortIndex++;
            }
        }
        let mult = 1;
        if (sortHead.sortDown) {
            mult = -1;
        }
        Log_1.default.trace("SortableTable::sort() - col: " + sortHead.id + "; down: " + sortHead.sortDown + "; mult: " + mult + "; index: " + sortIndex);
        this.rows = this.rows.sort(function (a, b) {
            const aVal = a[sortIndex].value;
            const bVal = b[sortIndex].value;
            if (typeof aVal === "string" && typeof bVal === "string") {
                const BUCKET_ORDER = ["", " ", "na", "n/a", "beginning", "acquiring", "developing", "proficient", "extending", "exceeding"];
                const aIndex = BUCKET_ORDER.indexOf(aVal.toLowerCase());
                const bIndex = BUCKET_ORDER.indexOf(bVal.toLowerCase());
                if (aIndex > -1 && bIndex > -1) {
                    return Util_1.default.compare(aIndex, bIndex) * mult;
                }
            }
            return Util_1.default.compare(aVal, bVal) * mult;
        });
    }
    downloadCSV(csv, fileName, linkName) {
        const csvFile = new Blob([csv], { type: "text/csv" });
        const downloadLink = document.createElement("a");
        downloadLink.innerHTML = linkName;
        const table = document.querySelector(this.divName);
        table.appendChild(downloadLink);
        downloadLink.download = fileName;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "block";
        downloadLink.style.textAlign = "center";
    }
    findColsWithMetadata(divName) {
        var _a;
        const root = document.querySelector(this.divName);
        const rows = root.querySelectorAll("table tr");
        let colsWithMetadata = [];
        for (let i = 1; i < rows.length; i++) {
            const cols = rows[i].querySelectorAll("td, th");
            for (let j = 0; j < cols.length; j++) {
                const col = cols[j];
                if (col.children.length > 0 &&
                    (col.children[0] instanceof HTMLAnchorElement || typeof ((_a = col.children[0]) === null || _a === void 0 ? void 0 : _a.title) === "string")) {
                    if (colsWithMetadata.indexOf(j) < 0) {
                        colsWithMetadata.push(j);
                    }
                }
            }
        }
        colsWithMetadata = colsWithMetadata.sort((a, b) => a - b);
        Log_1.default.info("SortableTable::findColsWithMetadata() - cols: " + JSON.stringify(colsWithMetadata));
        return colsWithMetadata;
    }
    static escapeHTML(value) {
        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    static csvField(value) {
        const text = (value !== null && value !== void 0 ? value : "").replace(/&nbsp;/g, " ").replace(/\u00a0/g, " ");
        if (/[",\r\n]/.test(text) === true) {
            return '"' + text.replace(/"/g, '""') + '"';
        }
        return text;
    }
    extractMetadata(elem) {
        var _a;
        let out = "";
        if (elem.children[0] instanceof HTMLAnchorElement) {
            out = SortableTable.csvField(elem.children[0].href);
        }
        else if (typeof ((_a = elem.children[0]) === null || _a === void 0 ? void 0 : _a.title) === "string") {
            out = SortableTable.csvField(elem.children[0].title);
        }
        return out;
    }
    exportTableToCSV() {
        var _a;
        const csv = [];
        const root = document.querySelector(this.divName);
        const colsWithMetadata = this.findColsWithMetadata(this.divName);
        const rows = root.querySelectorAll("table tr");
        const drawn = this.headers.filter((header) => this.isDrawn(header));
        for (let i = 0; i < rows.length; i++) {
            const row = [];
            const cols = rows[i].querySelectorAll("td, th");
            for (let j = 0; j < cols.length; j++) {
                if (((_a = drawn[j]) === null || _a === void 0 ? void 0 : _a.downloadable) === false) {
                    continue;
                }
                let text = cols[j].innerText;
                if (i === 0) {
                    text = text.replace(" ▼", "");
                    text = text.replace(" ▲", "");
                }
                text = text.trim();
                row.push(SortableTable.csvField(text));
                if (colsWithMetadata.indexOf(j) >= 0) {
                    if (i === 0) {
                        row.push(SortableTable.csvField(text + "_metadata"));
                    }
                    else {
                        row.push(this.extractMetadata(cols[j]));
                    }
                }
            }
            csv.push(row.join(","));
        }
        return csv.join("\n");
    }
    numRows() {
        return this.rows.length;
    }
    attachDownload() {
        const csv = this.exportTableToCSV();
        this.downloadCSV(csv, "classy.csv", "Download Values as CSV&nbsp;");
    }
    updateTableHeight() {
        Log_1.default.info("SortableTable::updateTableHeight() - table: " + this.divName);
        if (this.numRows() < 20) {
            Log_1.default.info("SortableTable::updateTableHeight() - skipped; # rows: " + this.numRows() + "; table: " + this.divName);
            return;
        }
        try {
            let offset = 0;
            let node = document.querySelector(this.divName);
            while (node.offsetParent && node.offsetParent.id !== "wrapper") {
                offset += node.offsetTop;
                node = node.offsetParent;
            }
            const visibleHeight = node.offsetHeight - offset + "px";
            node = document.querySelector(this.divName);
            node.style.height = visibleHeight;
        }
        catch (err) {
            Log_1.default.error("SortableTable::updateTableHeight() - ERROR: " + err.messsage);
        }
    }
}
exports.SortableTable = SortableTable;
